export enum AppThemeEnum {
  DARK,
  LIGHT
}

export interface AppThemeState {
  theme: AppThemeEnum;
}
